import { Component, OnInit } from '@angular/core';
import { Outcome } from '../../models/outcomes/Outcome';
import { ModalController, AlertController } from '@ionic/angular';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ValidationService } from 'src/app/services/validation.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { OutcomeGroupsService } from 'src/app/services/outcome-groups.service';
import { OutcomeGroupOutcomeRelation } from 'src/app/models/outcomes/OutcomeGroupOutcomeRelation';
import { ApiOutcomeService } from 'src/app/api-services/scene-outcome.api.service';
import { OutcomesService } from 'src/app/services/outcomes.service';
import { ApiProjectOutcomeRelationService } from 'src/app/api-services/project-outcome-relation.api.service';
import { ProjectOutcomeRelation } from 'src/app/models/outcomes/ProjectOutcomeRelation';
import { Project } from 'src/app/models/Project';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-add-outcome-to-project-modal',
  templateUrl: './add-outcome-to-project-modal.page.html',
  styleUrls: ['./add-outcome-to-project-modal.page.scss'],
})
export class AddOutcomeToProjectModalPage implements OnInit {

  public shouldAddNewOutcome: boolean;
  public shouldAddExisting: boolean;
  public outcomeGroupId;
  public Outcomes;
  public OutcomesCopy: Outcome[] = [];
  public OutcomeCount: number;
  public searchNotFound = false;
  public outcome = {} as Outcome;
  public outcomeSearchTerm;
  public minDate = new Date().toISOString();
  public OutcomesOriginal: Outcome[] = [];
  public projectId:number;


  constructor(
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public validationService: ValidationService,
    public deepCopyService: DeepCopyService,
    public outcomeGroupService: OutcomeGroupsService,
    public alertController: AlertController, 
    public outcomeApiService: ApiOutcomeService,
    public outcomeService: OutcomesService,
    public projectOutcomeRelationApiService: ApiProjectOutcomeRelationService,
    public messageService: MessagesService
  ) { }

  ngOnInit() {
    this.OutcomesCopy = this.deepCopyService.deepCopy(this.Outcomes);
    this.OutcomesOriginal = this.deepCopyService.deepCopy(this.Outcomes);
  }

  closeModal() {
    this.modalController.dismiss();
  }

  addNewOutcome(){
    this.shouldAddNewOutcome=true;
  }

  addExistingOutcome(){
    this.shouldAddExisting=true;
  }

  searchByOutcome(event) {
    this.updateCopy();
    let title: string = event.target.value;
    this.Outcomes = this.deepCopyService.deepCopy(this.OutcomesCopy);
    var outcomes = this.Outcomes.filter(x => x.title.toLowerCase().includes(title.toLowerCase()));
    if (outcomes.length == 0) {
      this.searchNotFound = true;
      this.Outcomes = this.deepCopyService.deepCopy(this.OutcomesCopy);
    }
    else {
      this.searchNotFound = false;
      this.Outcomes = outcomes;
    }
  }

  updateCopy() {
    this.OutcomesCopy.forEach(x => {
      var found = this.Outcomes.find(y => y.outcomeId == x.outcomeId);
      if (found) {
        x.checked = found.checked;
      }
    });
  }

  resetOutcomeLists() {
    this.OutcomesCopy.forEach(x => {
      x.checked = false;
    });

    this.Outcomes.forEach(x => {
      x.checked = false;
    });
  }

  addOutcome(ev) {
    this.unfocusService.unfocus(ev);
    if (this.shouldAddExisting) {
      var selected = [] as ProjectOutcomeRelation[];
      var selectedOutcomes = this.Outcomes.filter(x=>x.checked);
      selectedOutcomes.forEach(outcome => {
        let projectOutcomeRelation = {} as ProjectOutcomeRelation;
        projectOutcomeRelation.projectId = this.projectId;
        projectOutcomeRelation.outcomeId = outcome.outcomeId;
        projectOutcomeRelation.projectOutcomeRelationId =0;
        selected.push(projectOutcomeRelation);
      });
      
      
      if(selected.length !=0){
        this.messageService.presentLoadingWindow("Adding Outcome...");
        this.projectOutcomeRelationApiService.AddProjectOutcomeRelationArray(selected).subscribe(x=>
          {
            this.messageService.loadingWindow.dismiss();
            this.modalController.dismiss(selected);
          });
      }
    }
    else {
      this.saveOutcome();
    }
  }

  setNegativeToZero(event) {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
  }

  async saveOutcome() {
    this.outcome.title = this.validationService.removeHtmlTags(this.outcome.title);
    if (this.validationService.isOutcomeValid(this.outcome)) {
      if (!this.outcome.credits) {
        this.outcome.credits = 0;
      }
      this.outcome.isGroup = true;
      //if (this.validationService.checkOutcomeDate(new Date(this.outcome.expiryDate))) {
        this.messageService.presentLoadingWindow("Adding Outcome...");
        await this.outcomeApiService.addOutcome(this.outcome).subscribe(x => {
          let projectOutcomeRelation = {} as ProjectOutcomeRelation;
            projectOutcomeRelation.outcomeId = x.outcomeId;
            projectOutcomeRelation.projectId = this.projectId;
            projectOutcomeRelation.projectOutcomeRelationId = 0;
            this.projectOutcomeRelationApiService.addProjectOutcomeRelation(projectOutcomeRelation).subscribe(z=>{
              this.outcomeService.getOutcomesFromDb().then(y=>{
                this.messageService.loadingWindow.dismiss();
                this.modalController.dismiss(this.outcome);
              })
            });
        });
      //}
      // else {
      //   this.alertForIncorrectData("You have entered an incorrect expiry date.");
      // }

    } else {
      this.validationService.alertForMissingOutcomeProperties(this.outcome);
    }

  }

  async alertForIncorrectData(message: string) {
    const alert = await this.alertController.create({
      header: 'Learning Objective Error: ' + message,
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

}
